export default function WorkGallery1() {

  return (
      <section className="py-13">
        <div className="sm:w-11/12 mx-auto px-4 sm:px-0 flex flex-col gap-4">


                  {/* Row 2 - 2 columns - hidden on mobile */}

            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-2.png" alt="Mobile banking" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-3.png" alt="Petrol station" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-18.png" alt="Petrol station" className="w-full object-cover block" />
            </div>



            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-4.png" alt="Mobile banking" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-5.png" alt="Petrol station" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-19.png" alt="Petrol station" className="w-full object-cover block" />
            </div>


                    {/* Row 2 - 2 columns - hidden on mobile */}

            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-6.png" alt="Mobile banking" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-7.png" alt="Petrol station" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-14.png" alt="Petrol station" className="w-full object-cover block" />
            </div>


          {/* Row 2 - 2 columns - hidden on mobile */}

            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-8.png" alt="Mobile banking" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-9.png" alt="Petrol station" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-15.png" alt="Petrol station" className="w-full object-cover block" />
            </div>


          {/* Row 3 - 3 columns - single column on mobile */}

            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-10.png" alt="Chase campaign" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-16.png" alt="Hibex" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden">
              <img src="/AutoHaus-17.png" alt="Hook brand" className="w-full object-cover block" />
            </div>


          {/* Row 5 - 3 columns - single column on mobile */}
 
            <div className="rounded-3xl overflow-hidden aspect-square">
              <img src="/AutoHaus-13.png" alt="Disney+" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden aspect-square">
              <img src="/AutoHaus-11.png" alt="Petrol station" className="w-full object-cover block" />
            </div>
            <div className="rounded-3xl overflow-hidden aspect-square">
              <img src="/AutoHaus-12.png" alt="Banking app" className="w-full object-cover block" />
            </div>


          

        </div>
      </section>
  );
}